/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, forwardRef, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SelectionOptionValue } from '../../../../shared/models/internal/selection-option-value';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-multi-selection',
  imports: [FormsModule, ReactiveFormsModule, NgClass],
  templateUrl: './multi-selection.component.html',
  styleUrl: './multi-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectionComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: MultiSelectionComponent,
    },
  ],
})
export class MultiSelectionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() public options: SelectionOptionValue[] = [];
  @Input() public invalidOption?: string;
  @Input() public fullWidth = false;
  @Input() public unsavedChanges = false;

  public selectionControl!: FormControl;

  public ngOnInit(): void {
    const validators = [];
    if (this.invalidOption) {
      validators.push(this.isNotValidOptionValidator(this.invalidOption));
    }
    this.selectionControl = new FormControl('', validators);
    this.selectionControl.valueChanges.subscribe((value) => {
      this.onChange(value);
    });
  }

  public writeValue(value: string): void {
    // Set the value of the FormControl
    if (value !== undefined) {
      this.selectionControl.setValue(value, { emitEvent: false });
    }
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.selectionControl.disable();
    } else {
      this.selectionControl.enable();
    }
  }

  public onSelectionChange(): void {
    this.onTouched();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public validate(control: AbstractControl): ValidationErrors | null {
    return this.selectionControl.errors;
  }

  private isNotValidOptionValidator(invalidOption: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value === invalidOption) {
        return { invalidOption: true };
      }
      return null;
    };
  }

  private onChange: (value: string) => void = () => {};

  private onTouched: () => void = () => {};
}
